module.exports = __webpack_public_path__ + "static/img/son9.22928763.png";